import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import styles from "../../screens2/Requirement/Requirement.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatTime,
} from "../../utils/const";
import { useState, useEffect } from "react";
import RequirementList from "../../components/containers/RequirementList";
import { useLocation, useNavigate } from "react-router-dom";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { useDispatch, useSelector } from "react-redux";
import {
  applyCandidateOnJob,
  getAppliedCandidateById,
} from "../../redux/jobTimeline/jobTimelineSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../redux/common/locationSlice";
import { getAllCandidate } from "../../redux/candidate/candidateSlice";
import { allSkill } from "../../redux/common/skillSlice";
import CandidateListApplyDrawer from "../../screens2/Requirement/CandidateListApplyDrawer";
import ApplyCandidateListViewer from "./ApplyCandidateListViewer";
const ApplyJobDetailsViewedrawer = ({ handleClose, show, jobdata }) => {
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const [showAplly, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [isRemoveResume, setIsRemoveResume] = useState(false);
  const [page, setPages] = useState(1);
  const [showCandidate, setShowCandidate] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const handleCloseShowCandidate = () => setShowCandidate(false);
  const handleShowCandidate = () => setShowCandidate(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locations = useSelector((state) => state.location);
  const workautho = useSelector((state) => state.workautho);
  const profile = useSelector((state) => state.profile.data);
  const skillData = useSelector((state) => state.skill.data);
  const appliedCandidateData = useSelector(
    (state) => state.jobtimeline.appliedCandidateData
  );

  const appliedCandidatesCount = jobdata?.job_applications?.length || 0;
  const MAX_CANDIDATES = 5 - appliedCandidatesCount;

  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const jobtimelineStatus = useSelector(
    (state) => state.jobtimeline?.viewStaus
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseRemoveResume = () => {
    setOpen(false);
  };

  const getSkillNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          skillData?.locations?.find((location) => location.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  useEffect(() => {
    let jobID = jobdata?.job_id;
    dispatch(getAppliedCandidateById(jobID));
  }, [jobdata]);

  useEffect(() => {
    if (jobtimelineStatus === "remove_candidate_suceed") {
      let jobID = jobdata?.job_id;
      dispatch(getAppliedCandidateById(jobID));
      dispatch(getAllCandidate(`page=${page}&job_id=${jobID}`));
    }
  }, [jobdata, jobtimelineStatus, page]);

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());

    dispatch(allSkill());
  }, [dispatch]);

  const handleOnClickYes = () => {
    setIsRemoveResume(true);
    handleCloseRemoveResume();
  };

  const selectedCandidates = candidates
    ?.filter((candidate) => candidate.check)
    ?.map(({ id, rate, is_job_applied }) => ({
      id,
      rate,
      ...(is_job_applied !== undefined && { is_job_applied }),
    }));

  const handleOnClickApply = () => {
    let values = {
      job_id: jobdata?.job_id,
      candidate_resume_ids: selectedCandidates,
    };
    dispatch(applyCandidateOnJob(values));
  };

  useEffect(() => {
    if (jobtimelineStatus === "apply_candidate_requirement_succsess") {
      let jobID = jobdata?.job_id;
      dispatch(getAppliedCandidateById(jobID));
      dispatch(getAllCandidate(`page=${page}&job_id=${jobID}`));
      handleCloseShowCandidate();
    }
  }, [jobtimelineStatus, page]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "65%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          className={styles.track_submissions_heading}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 10px",
            margin: "0",
            width: "96%",
          }}
        >
          <Typography>
            <b> Job Post by {jobdata?.posted_by}</b>
          </Typography>

          <Typography>
            {jobdata?.created_at !== undefined &&
              formatDate(jobdata?.created_at)}
            ,{" "}
            {jobdata?.created_at !== undefined &&
              formatTime(jobdata?.created_at)}
          </Typography>
        </Box>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            alignSelf: "baseline",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Box>
          <Box
            className={styles.profile_and_submit}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <Typography>
                    Job ID: <b>{jobdata?.job_id}</b>
                  </Typography>

                  <Typography>
                    <b>
                      {jobdata?.job_title}, Exp {jobdata?.experience} Years{" "}
                    </b>
                  </Typography>
                  <Typography>
                    <b>{getPreferLocationNames(jobdata?.location)}</b>
                  </Typography>
                  <Typography>
                    <b>{convertArrayToString(jobdata?.requirement_type)} </b>
                  </Typography>
                  <Typography>
                    <b> {jobdata?.mode_of_interview} </b>
                  </Typography>
                  <Typography>
                    <b>
                      {jobdata?.rate !== "" || jobdata?.rate !== null
                        ? `$${jobdata?.rate} ${
                            jobdata?.requirement_type?.includes("full_Time")
                              ? "K Yearly"
                              : " Hourly"
                          }`
                        : "Not disclosed"}{" "}
                    </b>
                  </Typography>
                  {/* <Typography sx={{ marginTop: "10px !important" }}>
                    {jobdata?.client_name !== "" &&
                      jobdata?.client_name !== null && (
                        <span>
                          Client : <b>{jobdata?.client_name}</b>
                        </span>
                      )}
                  </Typography> */}
                </span>
              </span>
            </Box>
            <span style={{ alignSelf: "baseline" }}>
              <Typography
                sx={{ fontSize: "25px !important", textAlign: "center" }}
              >
                <b>{jobdata?.no_of_opening}</b>
              </Typography>
              <Typography>
                <b>No. Of Opening</b>{" "}
              </Typography>
            </span>
          </Box>

          <Box className={styles.candidate_text} sx={{ marginBottom: "14px" }}>
            <span>
              <Typography sx={{ padding: "10px 0 0 15px !important" }}>
                <b>Job description</b>
              </Typography>
              <Typography>
                <p style={{ padding: "0" }}>
                  {" "}
                  {jobdata?.job_description?.split("\n")?.map(
                    (line, index) =>
                      line?.trim() && (
                        <p
                          key={index}
                          style={{ marginBottom: "2px", padding: "0" }}
                        >
                          {line}
                        </p>
                      )
                  )}
                </p>
              </Typography>
              <Typography>
                <b>Mandatory Skills</b>
                <p style={{ padding: "10px 0" }}>
                  {getSkillNames(jobdata?.skills)}
                </p>
              </Typography>
            </span>
          </Box>

          <div
            style={{
              backgroundColor: "#fff",
              padding: "5px 10px 5px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box className={styles.recruiter_profile}>
              <div>
                <img
                  src={appliedCandidateData?.recruiter_details?.profile_picture}
                  alt=""
                />
                <span style={{ color: customTextColor }}>
                  <Typography>
                    <b>{appliedCandidateData?.recruiter_details?.full_name}</b>
                  </Typography>
                  <Typography>
                    <b>
                      {appliedCandidateData?.recruiter_details?.designation} at{" "}
                      {appliedCandidateData?.recruiter_details?.company_name}
                    </b>
                  </Typography>

                  <Typography sx={{ marginBottom: "5px !important" }}>
                    <Box>
                      <Typography>
                        <b>
                          E-Mail ID:{""}
                          {appliedCandidateData?.recruiter_details?.email}
                        </b>
                      </Typography>

                      <Typography sx={{ marginLeft: "10px" }}>
                        <b style={{ marginLeft: "10px" }}>
                          Phone No:{" "}
                          {appliedCandidateData?.recruiter_details?.mobile_no}
                        </b>
                      </Typography>
                    </Box>
                  </Typography>
                </span>
              </div>
            </Box>
            <Box className={styles.internal_update_apply_btns}>
              <button
                style={{
                  backgroundColor: "rgb(56, 86, 166)",
                  padding: "7.5px 20px ",
                }}
                onClick={handleShowCandidate}
              >
                Apply Now
              </button>
              <Box></Box>
            </Box>
          </div>
        </Box>

        <Box
          className={styles.requiter_profile_section}
          sx={{ backgroundColor: "#f8f9fa", padding: "1px" }}
        >
          {jobtimelineStatus === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 230,
              }}
            >
              <CircularProgress size={30} color="info" />
            </Box>
          ) : (
            appliedCandidateData?.job_applications?.length > 0 &&
            appliedCandidateData?.job_applications?.map((res) => {
              return (
                <RequirementList
                  image={profile_image}
                  name={res?.candidate_full_name}
                  skill={res?.candidate_current_job_title}
                  location={getPreferLocationNames(
                    res?.candidate_prefer_location
                  )}
                  status={getWorkAuthorization(
                    res?.candidate_work_authorization
                  )}
                  btn1="Remove"
                  btn2="Latter"
                  candidate={res}
                  jobdata={jobdata}
                />
              );
            })
          )}
        </Box>

        <CandidateListApplyDrawer
          handleShow={handleShow}
          handleClose={handleCloseShow}
          show={showAplly}
          handleClickOpen={handleClickOpen}
          isRemoveResume={isRemoveResume}
          jobdata={jobdata}
          MAX_CANDIDATES={MAX_CANDIDATES}
          setPages={setPages}
          page={page}
        />
      </Offcanvas.Body>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleCloseRemoveResume}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Remove Resume"}
        </DialogTitle>
        <DialogContent>
          Are you sure you want to Remove your Resume?
        </DialogContent>

        <DialogActions className="forgot_password_modal_btns">
          <button type="submit" onClick={handleOnClickYes}>
            Yes
          </button>
          <button type="submit" onClick={handleCloseRemoveResume}>
            No
          </button>
        </DialogActions>
      </Dialog>
      <ApplyCandidateListViewer
        handleShow={handleShowCandidate}
        handleClose={handleCloseShowCandidate}
        show={showCandidate}
        handleOnClickApply={handleOnClickApply}
        setCandidates={setCandidates}
        candidates={candidates}
      />
    </Offcanvas>
  );
};

export default ApplyJobDetailsViewedrawer;
